import { render, staticRenderFns } from "./totalPriceModal.vue?vue&type=template&id=67a97f1e&scoped=true&"
import script from "./totalPriceModal.vue?vue&type=script&lang=js&"
export * from "./totalPriceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a97f1e",
  null
  
)

export default component.exports